import { __isKnytElementComposed, __knytElementComposedRenderer, } from "./constants.js";
/**
 * A type guard to check if an element is a `KnytElementComposed`.
 *
 * @internal scope: workspace
 */
export function isKnytElementComposed(element) {
    return (typeof element === "object" &&
        __knytElementComposedRenderer in element &&
        typeof element[__knytElementComposedRenderer] === "function");
}
/**
 * A type guard to check if a constructor is a `KnytElementComposed.Constructor`.
 *
 * @internal scope: workspace
 */
export function isKnytElementComposedConstructor(constructor) {
    return (typeof constructor === "function" &&
        __isKnytElementComposed in constructor &&
        constructor[__isKnytElementComposed] === true);
}
